import { render, staticRenderFns } from "./AlertConfirm.vue?vue&type=template&id=0a85f1db&scoped=true&"
import script from "./AlertConfirm.vue?vue&type=script&lang=js&"
export * from "./AlertConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AlertConfirm.vue?vue&type=style&index=0&id=0a85f1db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85f1db",
  null
  
)

export default component.exports